// extracted by mini-css-extract-plugin
export var headerXL = "styles-module--headerXL--1hY8G";
export var headerL = "styles-module--headerL--2FKg_";
export var headerM = "styles-module--headerM--14ofe";
export var headerS = "styles-module--headerS--1tkp4";
export var headerXS = "styles-module--headerXS--21nZm";
export var blogHeaderXL = "styles-module--blogHeaderXL--3QpkS";
export var blogHeaderL = "styles-module--blogHeaderL--2XKiQ";
export var blogHeaderM = "styles-module--blogHeaderM--2VkyE";
export var blogHeaderS = "styles-module--blogHeaderS--2yiw-";
export var blogHeaderXS = "styles-module--blogHeaderXS--1-HYi";
export var headerPreamble = "styles-module--headerPreamble--OJhHl";
export var preHeader = "styles-module--preHeader--F62fI";
export var textNormal = "styles-module--textNormal--3vKJQ";
export var textSmall = "styles-module--textSmall--3tgVd";
export var textSmallAlternate = "styles-module--textSmallAlternate--1CtJu";
export var legend = "styles-module--legend--2xmgt";
export var caption = "styles-module--caption--1rkY5";
export var gradientBackground = "styles-module--gradientBackground--2gbde";
export var ellipsis = "styles-module--ellipsis--1ruz5";
export var globalContainer = "styles-module--globalContainer--2e_xv";
export var maxWidth = "styles-module--maxWidth--3iUE0";
export var clipBottom = "styles-module--clipBottom--Od1zG";
export var clipTopBottom = "styles-module--clipTopBottom--3_ukJ";
export var whiteBackground = "styles-module--whiteBackground--2HGz2";
export var regularContainer = "styles-module--regularContainer--36fAg";
export var translateTop = "styles-module--translateTop--mUMWR";
export var ch2 = "styles-module--ch2--3tZzp";
export var ch2Container = "styles-module--ch2-container--2QHcU";